import Empty from '../../components/empty/Empty'

import './pages.css'

const Video = ({isCurrent, data}) => {

      if(isCurrent !== 'video') return 

      if(data.data){
            return (
                  <div className={isCurrent === 'video' ? "content_page show" : "content_page"}>
                        <Empty text={`Not Found Video`}/>
                  </div>
            )
      }

      return (
            <div className={isCurrent === 'video' ? "content_page show" : "content_page"}>
                  <div className="content_page__inner video">
                        <h3 className="video_title">{data[0].title}</h3>
                        <div className="video_box">
                        <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${data[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                  </div>
            </div>
      )

}

export default Video
